import { useMutation } from '@hooks/reactQuery';

import { updateNoFileRules } from '@api/alarmManagement';

import { TAlarmUpdateNoVeRuleDTO } from '@interfaces/alarms/dto/alarmsDTO';

import { ALARM_UPDATE_NO_FILE_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsUpdateNoFileRulesReturn {
	updateAlarmNoFileRules: (data: TAlarmUpdateNoVeRuleDTO[]) => void;
	isLoadingUpdateAlarmNoFileRules: boolean;
}

export const useMutateAlarmsUpdateNoFileRules = (): IUseMutateAlarmsUpdateNoFileRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<TAlarmUpdateNoVeRuleDTO[]>({
		mutationKey: [ALARM_UPDATE_NO_FILE_RULE_ORAN],
		mutationFn: updateNoFileRules,
	});

	return {
		updateAlarmNoFileRules: mutateAsync,
		isLoadingUpdateAlarmNoFileRules: isLoading,
	};
};
